export default __webpack_public_path__ + "ae7affd080aff299fc48d72f65d34c35.png";